import { Injectable } from '@angular/core';
import { BaseSseAccessTokenProvider } from '@libs/shared/services/base-sse.service';
import { AuthService } from '@sprint-expert/app/core/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class SseAccessTokenProvider implements BaseSseAccessTokenProvider {
  constructor(private authService: AuthService) {}

  getAccessToken(): string {
    return this.authService.accessToken;
  }
}
